import { setIsApiSuccessful } from "../../../../features/pageSpeedPerformanceSlice";
import {
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../features/userSlice";
import { quarterlySpeedGoalsService } from "../../../../services/api/quaterly-speed-goals.endpoints";
import store from "../../../../store";

async function getQuarterlySpeedGoals(
  oauthTokenHeader: string,
  website_shared_uid: string,
  setData: any,
  setError: any
) {
  try {
    const response = await quarterlySpeedGoalsService.getQuarterlyGoals(
      oauthTokenHeader,
      website_shared_uid
    );
    if (!response.status || response.status !== 200) {
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Quarterly goals', type: 'error' }))); */
    } else {
      setData(response?.data);
    }
  } catch (e: any) {
    setError(e);
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function createQuarterlySpeedGoals(
  oauthTokenHeader: any,
  website_shared_uid: any,
  data: any
) {
  try {
    const response = await quarterlySpeedGoalsService.createQuarterlyGoals(
      oauthTokenHeader,
      website_shared_uid,
      data
    );
    if (
      !response.status ||
      response.status !== 201 ||
      response.status === 400
    ) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Creating Quarterly goals",
          type: "error",
        })
      );
    } else {
      store.dispatch(setIsApiSuccessful(true));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function editQuarterlySpeedGoals(
  oauthTokenHeader: any,
  website_shared_uid: any,
  data: any
) {
  try {
    const response = await quarterlySpeedGoalsService.editQuarterlyGoals(
      oauthTokenHeader,
      website_shared_uid,
      data
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Editing Quarterly goals",
          type: "error",
        })
      );
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Quarterly Goal Have Been Edited Successfully",
          type: "success",
        })
      );
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getDevices(oauthTokenHeader: string, setDevices: any) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await quarterlySpeedGoalsService.getDevices(
      oauthTokenHeader
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    }
    setDevices(response?.data?.data); // Set the fetched data
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getPageViewInternalList(
  oauthTokenHeader: string,
  website_shared_uid: string,
  setPageInternalListData: any,
  trackPromise: any
) {
  try {
    const response = await quarterlySpeedGoalsService.getPageViewInternalList(
      oauthTokenHeader,
      website_shared_uid
    );
    if (!response.status || response.status !== 200) {
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Quarterly goals', type: 'error' }))); */
      //  setErrorAccToPageStatus(response)
    } else {
      store.dispatch(setIsLoading(true));
      setPageInternalListData(response?.data?.data);
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function togglePageSpeed(
  oauthTokenHeader: string,
  data: any,
  website_shared_uid: any,
  psi_shared_uid: any,
  setTogglePageSpeedData: any
) {
  try {
    const response = await quarterlySpeedGoalsService.putTogglePageSpeed(
      oauthTokenHeader,
      data,
      website_shared_uid,
      psi_shared_uid
    );
    if (!response.status || response.status !== 200) {
      /*  setSnackbarOpen(false) */
      /* store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' })); */
    } else {
      store.dispatch(setIsLoading(true));
      setTogglePageSpeedData([response?.data?.data]);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function postPageSpeedInternal(
  oauthTokenHeader: string,
  data: any,
  website_shared_uid: any,
  setPostedPageSpeedContent: any,
  setErrorAccToPageStatus: any
) {
  try {
    const response = await quarterlySpeedGoalsService.postPageSpeedInternal(
      oauthTokenHeader,
      data,
      website_shared_uid
    );
    if (!response.status || response.status !== 201) {
      setErrorAccToPageStatus([response]);
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' }))); */
    } else {
      setPostedPageSpeedContent([response?.data?.data]);

      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Page scan request submitted successfully.",
          type: "success",
        })
      );
    }
  } catch (e: any) {
    if (e?.status !== undefined) {
      setErrorAccToPageStatus([e]);
      /*  trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))); */
    }

    /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: e || 'Unknown error occurred', type: 'error' }))); */
  }
}

export const QuarterlySpeedGoalsEndPointLogic = {
  getQuarterlySpeedGoals,
  createQuarterlySpeedGoals,
  editQuarterlySpeedGoals,
  getDevices,
  getPageViewInternalList,
  togglePageSpeed,
  postPageSpeedInternal,
};
